import { gql } from '@apollo/client';

export const ASK_ASSISTANT = gql`
  query ASK_ASSISTANT($question: String!) {
    askAssistant(question: $question) {
      answer
      users {
        id
        avatar {
          fileUrl
        }
        professions {
          id
          name
        }
        profile {
          id
          name
          city
          country
        }
      }
      projects {
        id
        title
        description
        type
        genres {
          id
          name
        }
        locations {
          id
          name
        }
        author {
          id
          avatar {
            fileUrl
          }
          profile {
            id
            name
          }
        }
        collaborations {
          id
          isFound
          requiredSkills {
            id
            name
          }
        }
      }
    }
  }
`;
